import { Box, CloseButton, Group, Text } from '@mantine/core';

type PopoverHeadProps = {
  switchOpenedState: () => void;
};

export const PopoverHead = ({ switchOpenedState }: PopoverHeadProps) => (
  <Box bg="dark.8" c="white" px={16} py={12} style={{ borderRadius: '12px 12px 0 0' }}>
    <Group justify="space-between" wrap="nowrap">
      <Text fw={600}>Wayflyer Sandbox</Text>
      <CloseButton aria-label="Close" variant="subtle" c="white" onClick={switchOpenedState} />
    </Group>
  </Box>
);
